import { Base, withIntersectionObserver } from '@studiometa/js-toolkit';

/**
 * Sentinel class.
 */
export class Sentinel extends withIntersectionObserver(Base, {
  threshold: 0,
  rootMargin: '0px 0px -100% 0px',
}) {
  /**
   * Config.
   */
  static config = {
    name: 'Sentinel',
  };
}
